import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Notification from "../../component/notification";

const students = [
  "John Doe",
  "Jane Smith",
  "Alex Johnson",
  "Maria Garcia"
];
const courses = [
  "Introduction to React",
  "Advanced JavaScript",
  "UI Design Principles",
  "Data Analysis with Python"
];
const initialAssignments = [
  { student: "John Doe", course: "Introduction to React", date: "May 1, 2023, 03:30 PM" },
  { student: "Jane Smith", course: "Advanced JavaScript", date: "May 2, 2023, 08:00 PM" },
  { student: "Alex Johnson", course: "UI Design Principles", date: "May 3, 2023, 02:45 PM" },
  { student: "Maria Garcia", course: "Data Analysis with Python", date: "May 4, 2023, 05:15 PM" },
  { student: "John Doe", course: "Introduction to React", date: "May 1, 2023, 03:30 PM" },
  { student: "Jane Smith", course: "Advanced JavaScript", date: "May 2, 2023, 08:00 PM" },
  { student: "Alex Johnson", course: "UI Design Principles", date: "May 3, 2023, 02:45 PM" },
  { student: "Maria Garcia", course: "Data Analysis with Python", date: "May 4, 2023, 05:15 PM" }, { student: "John Doe", course: "Introduction to React", date: "May 1, 2023, 03:30 PM" },
  { student: "Jane Smith", course: "Advanced JavaScript", date: "May 2, 2023, 08:00 PM" },
  { student: "Alex Johnson", course: "UI Design Principles", date: "May 3, 2023, 02:45 PM" },
  { student: "Maria Garcia", course: "Data Analysis with Python", date: "May 4, 2023, 05:15 PM" },
  { student: "John Doe", course: "Introduction to React", date: "May 1, 2023, 03:30 PM" },
  { student: "Jane Smith", course: "Advanced JavaScript", date: "May 2, 2023, 08:00 PM" },
  { student: "Alex Johnson", course: "UI Design Principles", date: "May 3, 2023, 02:45 PM" },
  { student: "Maria Garcia", course: "Data Analysis with Python", date: "May 4, 2023, 05:15 PM" },
  { student: "John Doe", course: "Introduction to React", date: "May 1, 2023, 03:30 PM" },
  { student: "Jane Smith", course: "Advanced JavaScript", date: "May 2, 2023, 08:00 PM" },
  { student: "Alex Johnson", course: "UI Design Principles", date: "May 3, 2023, 02:45 PM" },
  { student: "Maria Garcia", course: "Data Analysis with Python", date: "May 4, 2023, 05:15 PM" },
];

const AssignCourse = () => {
  const [assignments, setAssignments] = useState(initialAssignments);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [assignmentToDelete, setAssignmentToDelete] = useState(null);
  const [notification, setNotification] = useState({ visible: false, message: "", type: "" });
  const [selectedStudent, setSelectedStudent] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [search, setSearch] = useState("");
  const itemsPerPage = 10; 
  const [page, setPage] = useState(1);
  

  const handleShowDeleteModal = index => {
    setAssignmentToDelete(index);
    setShowDeleteModal(true);
  };

  const handleDeleteAssignment = () => {
    const newAssignments = assignments.filter((_, i) => i !== assignmentToDelete);
    setAssignments(newAssignments);
    setNotification({ visible: true, message: "Assignment deleted successfully!", type: "danger" });
    setTimeout(() => setNotification({ visible: false, message: "", type: "" }), 3000);
    setShowDeleteModal(false);
  };

  const handleAssign = e => {
    e.preventDefault();
    if (!selectedStudent || !selectedCourse) return;
    setAssignments([
      ...assignments,
      {
        student: selectedStudent,
        course: selectedCourse,
        date: new Date().toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true })
      }
    ]);
    setNotification({ visible: true, message: "Course assigned successfully!", type: "success" });
    setSelectedStudent("");
    setSelectedCourse("");
    setTimeout(() => setNotification({ visible: false, message: "", type: "" }), 3000);
  };

  const filteredAssignments = assignments.filter(a =>
    a.student.toLowerCase().includes(search.toLowerCase()) ||
    a.course.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filteredAssignments.length / itemsPerPage);
  const paginatedAssignments = filteredAssignments.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  return (
    <div className="container-fluid py-4" style={{ background: "#f7f8fa", minHeight: "100vh" }}>
      <Notification message={notification.message} type={notification.type} visible={notification.visible} onClose={() => setNotification({ visible: false, message: "", type: "" })} />
      <h1 style={{ fontWeight: 700 }}>Assign Courses</h1>
      <div style={{ color: "#888", marginBottom: 24 }}>Assign courses to students</div>
      <div className="row g-4">
        <div className="col-md-6">
          <div className="card p-4" style={{ borderRadius: 12,width:'500px' }}>
            <h4 style={{ fontWeight: 600 }}>Assign a Course</h4>
            <div style={{ color: "#888", marginBottom: 16, }}>Select a student and a course to assign</div>
            <Form onSubmit={handleAssign}>
              <Form.Group className="mb-3">
                <Form.Label style={{ fontWeight: 500 }}>Student</Form.Label>
                <Form.Select value={selectedStudent} onChange={e => setSelectedStudent(e.target.value)}>
                  <option value="">Select a student</option>
                  {students.map(s => <option key={s}>{s}</option>)}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-4">
                <Form.Label style={{ fontWeight: 500 }}>Course</Form.Label>
                <Form.Select value={selectedCourse} onChange={e => setSelectedCourse(e.target.value)}>
                  <option value="">Select a course</option>
                  {courses.map(c => <option key={c}>{c}</option>)}
                </Form.Select>
              </Form.Group>
              <Button type="submit" style={{ width: "100%", background: "#111", border: "none", fontWeight: 500, fontSize: 18, padding: 10 }}>Assign Course</Button>
            </Form>
          </div>
        </div>


        <div className="col-md-6">
          <div className="card p-4" style={{ borderRadius: 12,marginLeft:'-100px',width:'700px' }}>
            <h4 style={{ fontWeight: 600 }}>Current Assignments</h4>
            <div style={{ color: "#888", marginBottom: 16 }}>View and manage course assignments</div>
            <Form.Control
              type="text"
              placeholder="Search assignments..."
              className="mb-3"
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{ background: "#f7f8fa",width:'30%' }}
            />
            <div style={{ overflowX: "auto" }}>
              <table className="table align-middle">
                <thead>
                  <tr>
                    <th>Student</th>
                    <th>Course</th>
                    <th>Assigned Date</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedAssignments.map((a, i) => (
                    <tr key={i + (page - 1) * itemsPerPage}>
                      <td>{a.student}</td>
                      <td>{a.course}</td>
                      <td>{a.date}</td>
                      <td>
                        <Button variant="link" style={{ color: "#222" }} onClick={() => handleShowDeleteModal(i + (page - 1) * itemsPerPage)}>
                          <span className="bi bi-trash" style={{ fontSize: 18 }}>&#128465;</span>
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-2" style={{ color: "#888" }}>
              <div>Showing {filteredAssignments.length === 0 ? 0 : (page - 1) * itemsPerPage + 1} to {Math.min(page * itemsPerPage, filteredAssignments.length)} of {filteredAssignments.length} entries</div>
              <div>
                <Button variant="light" size="sm" onClick={() => setPage(page - 1)} disabled={page === 1}>{'<'}</Button>
                <span className="mx-2">Page {page} of {totalPages || 1}</span>
                <Button variant="light" size="sm" onClick={() => setPage(page + 1)} disabled={page === totalPages || totalPages === 0}>{'>'}</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this assignment?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteAssignment}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AssignCourse;